import { Box } from '@mui/material';
import CommunicationsPreview from 'components/communications-preview/communications-preview.component';
import AccountInboxListView from 'pages/account-inbox/account-inbox-list-view/account-inbox-list-view.component';
import React from 'react';
import { useViewOffers } from './view-offers.hooks';

const ViewOffers = () => {
  const props = useViewOffers();

  return (
    <CommunicationsPreview>
      <Box data-testid="ViewOffers.List">
        <AccountInboxListView {...props} preview />
      </Box>
    </CommunicationsPreview>
  );
};

export default ViewOffers;
